<style lang="scss">
  .cartContent {
    .bigBtn {
      width: auto;
      padding-right: 30px;
      padding-left: 30px;
    }
    table {
      thead,
      tbody {
        tr {
          th,
          td {
            &:nth-child(1) {
              padding-left: 0;
            }
            &:nth-child(3),
            &:nth-child(4),
            &:nth-child(5) {
              text-align: center;
            }
            &:nth-child(5) {
              max-width: 80px;
            }
          }
        }
      }
      thead {
        tr {
          th {
            text-transform: uppercase;
            border-top: none;
            border-bottom: 1px solid #f2f2f2;
          }
        }
      }
      tbody {
        tr {
          td {
            vertical-align: middle;
            border-bottom: 1px solid #f2f2f2;
            white-space: nowrap;
            img {
              max-width: 140px;
              height: auto;
            }
            p {
              white-space: normal;
              line-height: 28px;
            }
            strong {
              font-weight: 600;
            }
            .amount {
              display: inline-block;
              min-width: 30px;
              text-align: center;
            }
            .btn {
              width: 20px;
              height: 20px;
              background-size: contain;
              background-position: center;
              background-repeat: no-repeat;
              &.btnAmountMinus,
              &.btnAmountPlus {
                margin-top: -2px;
                height: 24px;
              }
              &.btnAmountMinus {
                margin-right: 20px;
                background-image: url('/static/images/icons/cart-left.svg');
              }
              &.btnAmountPlus {
                margin-left: 20px;
                background-image: url('/static/images/icons/cart-right.svg');
              }
              &.btnDelete {
                background-image: url('/static/images/icons/cart-delete.svg');
              }
            }
          }
        }
      }
      tfoot {
        tr {
          td {
            padding-right: 0;
            padding-left: 0;
            .tfootGrid {
              p {
                margin: 30px 0 40px 0;
                line-height: 30px;
                strong {
                  font-size: 16px;
                  font-weight: 600;
                }
                span {
                  float: right;
                }
              }
              .btn {
                width: 100%;
                margin: 10px 0;
              }
            }
          }
        }
      }
    }
    @media (min-width: 768px) {
      table tfoot tr td {
        .tfootGrid {
          display: grid;
          grid-template-columns: 1fr 260px;
          .btn {
            width: 260px;
          }
        }
      }
    }
  }
</style>
<template>
  <div class="cartContent">
    <FrontendNav></FrontendNav>
    <div class="container">
      <h1>Kosár</h1>
      <div v-if="cartItems.length">
        <table class="table table-responsive-lg">
          <thead>
            <tr>
              <th>Termék</th>
              <th>Leírás</th>
              <th>Mennyiség</th>
              <th>Ár</th>
              <th>Törlés</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in cartItems" :key="index">
              <td><img v-bind:src="item.imgUrl_url" v-bind:alt="item.title"></td>
              <td>
                <p>
                  <strong>{{item.title}}</strong><br>
                  {{item.author}}<br>
                  Árukód: {{item.sku}}
                </p>
              </td>
              <td>
                <button class="btn btn-clear btnAmountMinus" v-on:click="amountMinus(item)"></button>
                <strong class="amount">{{item.amount}}</strong>
                <button class="btn btn-clear btnAmountPlus" v-on:click="amountPlus(item)"></button>
              </td>
              <td><strong>{{item.price}} Ft/db</strong></td>
              <td><button class="btn btn-clear btnDelete" v-on:click="delModal(item)"></button></td>
            </tr>
          </tbody>
        </table>
        <table class="table">
          <tfoot>
            <tr>
              <td colspan="5" style="border: none">
                <div class="tfootGrid">
                  <div></div>
                  <div>
                    <p>
                      Termékek száma: <span>{{cartSumNum}} db</span><br>
                      <strong>Összesen: <span>{{cartSumPrice}} Ft</span></strong>
                    </p>
                  </div>
                  <div><a href="/konyvek" class="btn btn-outline">Vásárlás folytatása</a></div>
                  <div><a href="/rendeles/adatok" class="btn btn-primary">Tovább</a></div>
                </div>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <p v-else>A kosarad jelenleg üres.<br><br><a href="/konyvek" class="btn btn-primary bigBtn">Böngéssz a könyveink között</a></p>
      <div class="modal fade" id="delModal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Biztosan törli?</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <p>Biztosan törölni szeretné a <strong>{{itemToDelete.title}}</strong> című könyvet?</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Nem</button>
              <button type="button" class="btn btn-danger" data-dismiss="modal" v-on:click="deleteItem()">Igen, törlöm</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FrontendFooter></FrontendFooter>
  </div>
</template>

<script>
import FrontendNav from '../partials/nav'
import FrontendFooter from '../partials/footer'

export default {
  name: 'Cart',
  components: {
    FrontendNav,
    FrontendFooter
  },
  data: function () {
    return {
      cartSumPrice: 0,
      cartSumNum: 0,
      cartItems: [],
      itemToDelete: {}
    }
  },
  created: function () {
    if (localStorage.getItem('cartItems')) {
      try {
        this.cartItems = JSON.parse(localStorage.getItem('cartItems'))
      } catch (e) {
        localStorage.removeItem('cartItems')
      }
    }
    for (let item in this.cartItems) {
      this.cartItems[item].amount = 1
    }
    this.updateCart()
  },
  methods: {
    amountMinus: function (item) {
      if (item.amount > 1) {
        item.amount--
        this.updateCart()
      }
    },
    amountPlus: function (item) {
      if (item.amount < item.available_quantity) {
        item.amount++
        this.updateCart()
      }
    },
    delModal: function (item) {
      this.itemToDelete = item
      window.$('#delModal').modal('show')
    },
    deleteItem: function () {
      for (var i = 0; i < this.cartItems.length; i++) {
        if (this.itemToDelete.title === this.cartItems[i].title) {
          this.cartItems.splice(i, 1)
        }
      }
      this.updateLocalStorage()
    },
    updateCart: function () {
      this.cartSumNum = 0
      this.cartSumPrice = 0
      for (var i = 0; i < this.cartItems.length; i++) {
        this.cartSumNum += this.cartItems[i].amount
        this.cartSumPrice += this.cartItems[i].amount * this.cartItems[i].price
      }
      this.updateLocalStorage()
    },
    updateLocalStorage: function () {
      localStorage.setItem('cartSumPrice', this.cartSumPrice)
      const parsed = JSON.stringify(this.cartItems)
      localStorage.setItem('cartItems', parsed)
      this.$store.commit('loading/setCartNum', this.cartItems.length)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/frontend/cart/cart.vue